import React, { lazy, Suspense } from 'react';
import { ChatBotMicroFrontendProps } from './ChatBotMicroFrontend';
import './ChatBot.scss';

const ChatBotMicroFrontend = lazy(() =>
  import('./ChatBotMicroFrontend').then((m) => ({ default: m.ChatBotMicroFrontend }))
);

const ChatBotMicroFrontendPage: React.FC<ChatBotMicroFrontendProps> = (props) => {
  return (
    <div id="chat-bot-micro-frontend">
      <Suspense fallback={null}>
        <ChatBotMicroFrontend {...props} />
      </Suspense>
    </div>
  );
};

export default ChatBotMicroFrontendPage;